import { createContext } from 'react'
import { useRouter } from 'next/router'
import { getLanguageCodeByLocale } from '~/utils/localization'

const LanguageContext = createContext(null)

export const LanguageProvider = ({ children }) => {
  const router = useRouter()
  const locale = router.locale || 'en'
  const language = getLanguageCodeByLocale(locale)

  return <LanguageContext.Provider value={language}>{children}</LanguageContext.Provider>
}

export default LanguageContext
